export const GREEN_COLOR = '#22bb45';
export const ORANGE_COLOR = '#ffbf00';
export const ROSE_COLOR = '#FC8EAC';
export const LIGHT_BLUE_COLOR = '#64b5f6';
export const LIGHT_RED_COLOR = '#d86c70';
export const YELLOW_COLOR = '#fee715ff';
export const LIGHT_GRAY_COLOR = '#D6D7D8';
export const PURPLE_COLOR = '#9d07e8';
export const DARK_RED_COLOR = '#8b0000 '
export const TRANSPARENT = 'transparent';

export const colorShade = (color, amount = -40) => {
	let newColor = color.replace(/^#/, '');

	if (newColor.length === 3) {
		newColor = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
	}

	let [r, g, b] = newColor.match(/.{2}/g);
	[r, g, b] = [
		parseInt(r, 16) + amount,
		parseInt(g, 16) + amount,
		parseInt(b, 16) + amount
	];

	r = Math.max(Math.min(255, r), 0).toString(16);
	g = Math.max(Math.min(255, g), 0).toString(16);
	b = Math.max(Math.min(255, b), 0).toString(16);

	const rr = (r.length < 2 ? '0' : '') + r;
	const gg = (g.length < 2 ? '0' : '') + g;
	const bb = (b.length < 2 ? '0' : '') + b;

	return `#${rr}${gg}${bb}`;
};

export const getAppointmentColor = ({ isPayed, isReservation, isVestacenje, customerAttended, isOnline, isAbsent }, hover = false) => {
    if (customerAttended === false) {
		return hover ? colorShade(LIGHT_GRAY_COLOR) : LIGHT_GRAY_COLOR;
	}
	if (isPayed) {
		return hover ? colorShade(GREEN_COLOR) : GREEN_COLOR;
	}
    else if (isOnline) {
		return hover ? colorShade(PURPLE_COLOR) : PURPLE_COLOR;
	}
	else if (isAbsent) {
		return hover ? colorShade(DARK_RED_COLOR) : DARK_RED_COLOR;
	}
    else if (isReservation) {
		return hover ? colorShade(ORANGE_COLOR) : ORANGE_COLOR;
	}
    else if (isVestacenje) {
		return hover ? colorShade(ROSE_COLOR) : ROSE_COLOR;
	}
    return hover ? colorShade(LIGHT_BLUE_COLOR) : LIGHT_BLUE_COLOR;
};

export const getWorkerReportsColor = (months) => {
    const topIncomes = months.sort((a, b) => b.value - a.value);
    topIncomes.forEach((income, index) => {
        income.color = colorShade(LIGHT_RED_COLOR, index * 15);

        if (index < 9) {
            income.color = colorShade(ORANGE_COLOR, index * 15);
        }
        if (index < 6) {
            income.color = colorShade(YELLOW_COLOR, index * 15);
        }
        if (index < 3) {
            income.color = colorShade(GREEN_COLOR, index * 15);
        }
        if (parseFloat(income.value) === 0) {
            income.color = TRANSPARENT;
        }
    });

    return topIncomes.sort((a, b) => a.month - b.month);
}
